import { render, staticRenderFns } from "./Iletisim.vue?vue&type=template&id=7dc82cdc&scoped=true&"
import script from "./Iletisim.vue?vue&type=script&lang=js&"
export * from "./Iletisim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc82cdc",
  null
  
)

export default component.exports